<template>
  <div class="p-5">
    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <CustomerBorrowerAdd :is-external="true" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomerBorrowerAdd from '@/views/pages/Customer/Borrower/add.vue'
export default {
  components: {
    CustomerBorrowerAdd
  },
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
